<template>
  <div class="homePage">
    <div class="new_wrap flex-rowl">
      <div class="left flex-rowl">
        <i class="iconfont icon-xinxi"></i> 最新信息
      </div>
      <div class="box flex-rowl">暂无</div>
    </div>
    <div class="card_wrap">
      <div class="card_tit">常用功能快速入口</div>
      <div class="card_list flex-rowl">
        <div
          class="card_item flex-rowl"
          v-if="menuSKU.id"
          @click="handleGo(menuSKU.id, menuSKU)"
        >
          <el-image
            style="width: 32px"
            :src="menuSKU.icon"
            fit="contain"
          ></el-image>
          <p>添加&管理商品（SKU）</p>
        </div>
        <div
          class="card_item flex-rowl"
          v-if="menuOrder.id"
          @click="handleGo(menuOrder.id, menuOrder)"
        >
          <el-image
            style="width: 32px"
            :src="menuOrder.icon"
            fit="contain"
          ></el-image>
          <p>{{ menuOrder.funcname }}</p>
        </div>
        <div
          class="card_item flex-rowl"
          v-if="menuSet.id"
          @click="menuSet(menuOrder.id, menuSet)"
        >
          <el-image
            style="width: 32px"
            :src="menuSet.icon"
            fit="contain"
          ></el-image>
          <p>{{ menuSet.funcname }}</p>
        </div>

        <div class="card_item flex-rowl" @click="handleGo(4)">
          <i class="iconfont icon-qiyexinxi"></i>
          <span>个人&企业信息管理</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMenuAuthOne } from "../api/api";
export default {
  name: "home",
  data() {
    return {
      menuList: "",
      menuSKU: "",
      menuOrder: "",
      menuSet: "",
    };
  },
  created() {
    this.getMenuAuthOne();
  },
  methods: {
    getMenuAuthOne() {
      this.loading = true;
      getMenuAuthOne().then((res) => {
        // this.menuList = this.filterMenu(res);
        this.filterMenu(res).forEach((v) => {
          // sku管理
          if (v.id == "7067a2f9-44fd-4e17-8390-f78916082584") {
            v.two_authority.forEach((v1) => {
              if (v1.id == "2c826169-f20e-43b1-9a41-3aae606c97e0") {
                v1.icon = v.icon;
                this.menuSKU = v1;
              }
            });
          }
          // 物流&订单管理
          if (v.id == "493cdc58-5386-4ec3-80fe-6368800fbbba") {
            this.menuOrder = v;
          }
          // 基础设置&客服帮助
          if (v.id == "c52d7844-f7ba-418c-ab05-6b1fbb908fc3") {
            this.menuSet = v;
          }
        });
        this.loading = false;
      });
    },
    // 过滤菜单栏
    filterMenu(menuList) {
      let roleId = this.$store.state.USERINFO.roleid;
      return menuList
        .filter((item) => {
          //
          return (
            item.viewrange.split(",").indexOf(roleId) > -1 &&
            (item.id == "7067a2f9-44fd-4e17-8390-f78916082584" ||
              item.id == "2c826169-f20e-43b1-9a41-3aae606c97e0" ||
              item.id == "493cdc58-5386-4ec3-80fe-6368800fbbba" ||
              item.id == "c52d7844-f7ba-418c-ab05-6b1fbb908fc3")
          );
        })
        .map((item) => {
          item = Object.assign({}, item);
          if (item.two_authority) {
            item.two_authority = this.filterMenu(item.two_authority);
          }
          return item;
        });
    },

    handleGo(id, item) {
      // 判断是否有操作权限
      let roleId = this.$store.state.USERINFO.roleid;
      if (id == "2c826169-f20e-43b1-9a41-3aae606c97e0") {
        if (item.dorange.split(",").indexOf(roleId) == -1) {
          this.$message.warning("暂无操作权限");
          return;
        } else {
          this.$store.commit("setMenuList", item);
          this.$router.push(item.pagepath);
        }
      } else if (id == "7067a2f9-44fd-4e17-8390-f78916082584") {
        this.$message.warning("即将开放");
        return;
      } else if (id == "493cdc58-5386-4ec3-80fe-6368800fbbba") {
        this.$message.warning("即将开放");
        return;
      } else if (id == 4) {
        this.$router.push("/mine");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.homePage {
  padding: 150px 0;
  .new_wrap {
    margin: 0 260px 43px 120px;
    .left {
      white-space: nowrap;
      margin-right: 40px;
      font-size: 24px;
      color: #444444;
      .icon-xinxi {
        font-size: 40px;
        margin-right: 20px;
      }
    }
    .box {
      flex: 1;
      height: 230px;
      background: #fbfbfb;
      border: 1px solid #dcdcdc;
      border-radius: 30px;
      font-size: 20px;
      color: #444444;
      padding: 15px 50px;
    }
  }
  .card_wrap {
    padding: 0 65px;
    font-size: 24px;
    color: #444444;
    .card_tit {
      font-size: 20px;
      margin-bottom: 25px;
    }
    .card_list {
      flex-wrap: wrap;
      .card_item {
        cursor: pointer;
        flex-shrink: 0;
        width: calc((100% - 110px) / 3);
        height: 160px;
        background: #fbfbfb;
        box-shadow: 0px 0 7px 0px rgba(84, 79, 90, 0.1),
          0px -6px 0px 0px #6f5d88;
        //   box-shadow: 0px 0px 7px 0px rgba(84, 79, 90, 0.1), 0px 6px 0px 0px #6f5d88;
        border-radius: 30px;
        padding-left: 45px;
        box-sizing: border-box;
        margin-right: 55px;
        margin-bottom: 30px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .iconfont {
          font-size: 32px;
          margin-right: 20px;
        }
        .icon-tianjiashangpin {
          font-size: 42px;
          color: #e23e63;
          margin-right: 15px;
        }
        .icon-huowujilu {
          color: #762453;
        }
        .icon-qiyexinxi {
          color: #59486b;
        }
        .icon-touzijihuaguanli {
          color: #6b5d83;
        }
        p {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>